import './App.css';
import AppRoutes from './AppRoutes';
import ModalMensagens from './components/ModalMensagens';



function App() {

    return(
        <>
            <AppRoutes />
            <ModalMensagens />
        </>
    )
}

export default App;